import { client } from "./index";
import { vendor } from "../Constant/index";


export const getCategory = () => client.get(`category?email=${vendor}`);
